/* eslint-disable no-console */
import { Modal } from 'bootstrap';
import RequestHelper from '../helpers/request-helper';
import HotReward from '../helpers/hot-reward';
import CustomSelect from '../components/custom-select';
import SanitizationHelper from '../helpers/sanitization-helper';

const requestHelper = new RequestHelper();
const customSelect = new CustomSelect();

const detailItemTemplate = require('../twigs/detailItemTemplate.twig');
const redemptionCongratulationsTemplate = require('../twigs/redemptionCongratulationsTemplate.twig');
const rewardCarouselTemplate = require('../twigs/rewardCarouselTemplate.twig');
const itemRedemptionTemplate = require('../twigs/itemRedemptionTemplate.twig');
const couponRedemptionModalTemplate = require('../twigs/couponRedemptionModalTemplate.twig');
const sweepsRedemptionModalTemplate = require('../twigs/sweepsRedemptionModalTemplate.twig');

export default class RewardDetail {
    constructor() {
        this.modalContainer = document.getElementById('modal-container');

        this.state = {
            isShelter: FreshStep.isShelter,
            balance: 0,
            rewards: [],
            featuredReward: null,
            hotReward: null,
            data: null,
            states: Electro.states,
        };

        this.render();
    }

    initListeners() {
        $('.js-redeem-button').on('click', (e) => {
            e.preventDefault();

            const itemType = this.state.featuredReward.type;

            const isCoupon = $.inArray('Coupon', this.state.featuredReward.categories);
            const isSweeps = $.inArray('Sweepstakes', this.state.featuredReward.categories);

            if (isCoupon === 1 && itemType === 'digital') {
                // This is a Coupon
                this.renderCouponModal();
                this.state.rewardType = 'coupon';
            } else if (isSweeps === 1 && itemType === 'digital') {
                // This is a Sweepstakes
                this.renderSweepsModal();
                this.state.rewardType = 'sweeps';
            } else {
                this.renderItemForm();
                this.state.rewardType = 'physical';
            }
        });
    }

    renderCouponModal() {
        $(this.modalContainer).html(
            couponRedemptionModalTemplate({
                name: this.state.featuredReward.name,
                points: this.state.featuredReward.price,
            })
        );

        const  couponRedemptionModal = new Modal(this.modalContainer);
        couponRedemptionModal.show();

        this.state.data = {
            rewardId: this.state.featuredReward.id,
            quantity: 1,
        };

        $('.js-confirm-redemption').on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).addClass('processing');

            this.redeemReward();
        });
    }

    renderSweepsModal() {
        $(this.modalContainer).html(
            sweepsRedemptionModalTemplate({
                points: this.state.featuredReward.price,
                balance: this.state.balance,
            })
        );

        const sweepsModal = new Modal(this.modalContainer);
        sweepsModal.show();

        customSelect.customizeSelects();

        this.state.data = {
            rewardId: this.state.featuredReward.id,
            quantity: 1,
        };

        $('.js-redemption-error').html('').hide();

        $('#sweepsQuanity').on('change', '#qtySelect', (e) => {
            this.state.data.quantity = $(e.currentTarget).val();
        });

        $('.js-confirm-redemption').on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).addClass('processing');

            this.redeemReward();
        });
    }

    renderItemForm() {
        $('#featured-reward').hide();
        $('#recommended-rewards').hide();

        $('#main').append(
            itemRedemptionTemplate({
                imageAlt: `picture of ${this.state.featuredReward.name}`,
                imageSrcSmall: this.state.featuredReward.largeImageUrl,
                name: this.state.featuredReward.name,
                longDescription: this.state.featuredReward.longDescription,
                termsAndConditions: this.state.featuredReward.termsAndConditions,
                points: this.state.featuredReward.price,
                states: this.state.states,
                addressLine1: Electro.address.addressLine1,
                addressLine2: Electro.address.addressLine2,
                city: Electro.address.city,
                state: Electro.address.state,
                zip: Electro.address.zip,
            })
        );
        const $shippingForm = $('#js-shipping-form');
        if ($shippingForm.length > 0) {
            if (Electro.DEBUG) {
                console.info('Validating!');
            }

            $shippingForm.parsley();
        }

        $('.js-confirm-redemption').on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).addClass('processing');

            if ($shippingForm.parsley().validate()) {
                this.state.data = {
                    rewardId: this.state.featuredReward.id,
                    quantity: 1,
                    address: {
                        addressLine1: $shippingForm.find('input[name="mailing-address-1"]').val(),
                        addressLine2: $shippingForm.find('input[name="mailing-address-2"]').val(),
                        city: $shippingForm.find('input[name="city"]').val(),
                        state: $shippingForm.find('#state').val(),
                        zip: $shippingForm.find('input[name="zip-code"]').val(),
                    },
                };

                this.redeemReward();
            } else {
                $(e.currentTarget).removeClass('processing');
            }
        });

        $('.js-cancel-redemption').on('click', (e) => {
            e.preventDefault();

            RewardDetail.cancelRedemption();
        });
    }

    async renderCongratulations() {
        if (Electro.DEBUG) {
            console.info('RewardDetail.renderCongratulations()');
        }

        this.state.balance -= this.state.featuredReward.price * this.state.data.quantity;

        $('.js-point-balance').html(this.state.balance);

        let message;

        if (this.state.rewardType === 'sweeps') {
            message = `You will receive an email confirmation shortly. Enjoy!`;
        } else {
            message = `You successfully redeemed this reward. You’ll get an email confirmation in two shakes of a kitty’s tail.`;
        }

        $('#main').append(
            redemptionCongratulationsTemplate({
                balance: this.state.balance,
                message,
                type: this.state.rewardType,
            })
        );

        $('#featured-reward').remove();
        $('#recommended-rewards').remove();
        $('#item-redemption').remove();
    }

    redeemReward() {
        if (Electro.DEBUG) {
            console.info('RewardDetail.redeemReward()');
        }

        requestHelper
            .makeAuthenticatedRequest('/wp-json/electro/v1/paw-points/redeem-reward', 'POST', this.state.data)
            .then((response) => {
                if (Electro.DEBUG) {
                    console.info('response: ', response);
                }

                let dataLayer;
                if (response.status === 0) {
                    RewardDetail.resetRedemption();
                    this.renderCongratulations();
                    // push to GTM
                    dataLayer = [
                        {
                            productName: this.state.featuredReward.name,
                        },
                    ];
                } else {
                    console.info('ERROR: ', response.message);
                    const $confirmRedemption = $('.js-confirm-redemption');
                    $confirmRedemption.removeClass('processing');
                    $('.js-redemption-error').html(response.message).show();

                    if (response.message === 'That reward is not available. Please contact Customer Service.') {
                        $confirmRedemption.addClass('disabled');
                        $('.js-redeem-button').addClass('disabled');
                    }
                }
            });
    }

    static resetRedemption() {
        $('#modal-container').modal('hide');
    }

    static cancelRedemption() {
        window.location.reload();
    }

    findFeaturedReward() {
        const $detailID = $('#featured-reward').data('id');

        /**
         * @type {object} item
         * @property {string} item.largeImageUrl
         * @property {string} item.mediumImageUrl
         * @property {string} item.smallImageUrl
         * @property {int} item.quantityAvailable
         */
        this.state.rewards.forEach((item) => {
            if (item.id === $detailID) {
                this.state.featuredReward = item;

                const finalImageArray = [];
                let imageArray = [
                    this.state.featuredReward.largeImageUrl,
                    this.state.featuredReward.mediumImageUrl,
                    this.state.featuredReward.smallImageUrl,
                ];

                // Remove Duplicate Image URLs
                imageArray = imageArray.filter((elem, index, self) => index === self.indexOf(elem));

                // Remove empty keys from Object
                imageArray = Object.keys(imageArray)
                    .filter((k) => imageArray[k] != null)
                    .filter((k) => imageArray[k] !== '')
                    .reduce((a, k) => ({ ...a, [k]: imageArray[k] }), {});

                // Re-Key the Array and add to state
                $.each(imageArray, (index, value) => {
                    finalImageArray.push(value);
                });

                $('#featured-reward').html(
                    detailItemTemplate({
                        id: this.state.featuredReward.id,
                        imageAlt: `picture of ${this.state.featuredReward.name}`,
                        imageSrcSmall: this.state.featuredReward.smallImageUrl,
                        imageSrcMedium: this.state.featuredReward.mediumImageUrl,
                        imageSrcLarge: this.state.featuredReward.largeImageUrl,
                        imageArray: finalImageArray,
                        name: this.state.featuredReward.name,
                        longDescription: this.state.featuredReward.longDescription,
                        termsAndConditions: this.state.featuredReward.termsAndConditions,
                        categories: item.categories,
                        user: FreshStep.LOGGED_IN,
                        points: this.state.featuredReward.price,
                    })
                );

                if (finalImageArray.length > 1) {
                    setTimeout(RewardDetail.initProductSlider, 1000);
                }

                document.title = SanitizationHelper.stripTags(
                    `Paw Points Rewards Catalog | ${this.state.featuredReward.name}`
                );

                if (FreshStep.LOGGED_IN) {
                    this.runCalculator();
                }
            }
        });
    }

    populateCarousel() {
        let { rewards } = this.state;

        rewards = $.grep(rewards, (value) => value !== this.state.featuredReward);

        // Default sorting by asc cost
        rewards.sort((a, b) => {
            const a1 = a.price;
            const b1 = b.price;
            if (a1 === b1) return 0;
            return a1 > b1 ? 1 : -1;
        });

        $('#recommended-rewards').append(
            rewardCarouselTemplate({
                headline: 'You might also like',
                rewards,
                cta: true,
                dot: false,
                hotReward: this.state.hotReward,
                isShelter: this.state.isShelter,
            })
        );

        RewardDetail.initRewardSlider();
    }

    static initRewardSlider() {
        const $sliderRecommendedRewards = $('.slider--recommended-rewards');
        $sliderRecommendedRewards.slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 6,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 875,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrow: false,
                    },
                },
            ],
        });

        // Custom carousel nav
        $('.js-carousel-prev').click((e) => {
            e.preventDefault();
            $sliderRecommendedRewards.slick('slickPrev');
        });

        $('.js-carousel-next').click((e) => {
            e.preventDefault();
            $sliderRecommendedRewards.slick('slickNext');
        });
    }

    static initProductSlider() {
        $('#featured-reward').find('.slider--reward-images').slick({
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            prevArrow:
                '<button class="slick-prev slick-arrow"><img src="/wp-content/themes/electro/img/svg/icon-chevron-left-stone.svg" alt="Left"/></button>',
            nextArrow:
                '<button class="slick-next slick-arrow"><img src="/wp-content/themes/electro/img/svg/icon-chevron-right-stone.svg" alt="Right"/></button>',
        });
    }

    async fetchHotReward() {
        this.state.hotReward = await HotReward.fetchHotReward();
    }

    fetchRewardsCatalog() {
        requestHelper.makeRequest('/wp-json/electro/v1/paw-points/rewards-catalog', 'GET').then((response) => {
            if (response.data.items.length > 0) {
                // Is this a shelter?
                if (this.state.isShelter) {
                    const rewards = response.data.items;

                    // Remove all except for Shelter Exclusives
                    $.each(rewards, (index, value) => {
                        if (value.categories.includes('Shelter Exclusive') !== true) {
                            delete rewards[index];
                        }
                    });

                    // Remove empty keys from Object
                    const shelterRewards = Object.keys(rewards)
                        .filter((k) => rewards[k] != null)
                        .reduce((a, k) => ({ ...a, [k]: rewards[k] }), {});

                    // Re-Key the Array and add to state
                    $.each(shelterRewards, (index, value) => {
                        this.state.rewards.push(value);
                    });

                    if (Electro.DEBUG) {
                        console.info('this.state.rewards: ', this.state.rewards);
                    }

                    this.findFeaturedReward();
                    this.populateCarousel();
                } else {
                    const rewards = response.data.items;

                    // Remove all Shelter Exclusives
                    $.each(rewards, (index, value) => {
                        if (value.categories.includes('Shelter Exclusive') === true) {
                            delete rewards[index];
                        }
                    });

                    // Remove empty keys from Object
                    const consumerRewards = Object.keys(rewards)
                        .filter((k) => rewards[k] != null)
                        .reduce((a, k) => ({ ...a, [k]: rewards[k] }), {});
                    this.state.categories = response.data.categories;

                    // Re-Key the Array and add to state
                    $.each(consumerRewards, (index, value) => {
                        this.state.rewards.push(value);
                    });

                    this.findFeaturedReward();
                    this.populateCarousel();
                }
            }
        });
    }

    fetchPointBalance() {
        if (Electro.DEBUG) {
            // eslint-disable-next-line no-console
            console.info('RewardDetail.fetchPointBalance()');
        }

        requestHelper
            .makeAuthenticatedRequest('/wp-json/electro/v1/paw-points/user-points-total', 'POST')
            .then(async (response) => {
                this.state.balance = response.data;
                await this.fetchHotReward();
                this.fetchRewardsCatalog();
            });
    }

    runCalculator() {
        if (Electro.DEBUG) {
            console.info('RewardDetail.runCalculator()');
        }

        $('.js-point-balance').html(this.state.balance);

        if (this.state.balance >= this.state.featuredReward.price) {
            $('.js-point-progress').css('width', '100%');
            $('.js-balance-text').html('You have<br/>enough points!');
            $('.js-redeem-button').show();
        } else {
            const percentage = (this.state.balance / this.state.featuredReward.price) * 100;

            $('.js-point-progress').css('width', `${percentage}%`);
            $('.js-redeem-button').hide();
        }

        if (this.state.balance >= this.state.featuredReward.price && this.state.featuredReward.quantityAvailable > 0) {
            $('.js-redeem-button').removeClass('disabled');

            this.initListeners();
        } else {
            $('.js-redeem-button').addClass('disabled');
        }
    }

    async render() {
        if (Electro.DEBUG) {
            console.info('RewardDetail.render()');
        }

        if (FreshStep.LOGGED_IN) {
            this.fetchPointBalance();
        } else {
            await this.fetchHotReward();
            this.fetchRewardsCatalog();
        }
    }
}
